 import React from "react";
 import qrImg from "../../assets/qr.png";
 import vsb from "../../assets/vsb.jpeg"
 import './footer.css'
 const Publish = ()=>{
    return(<>
  <div className="ad-card-line vsb-ad-card">
    <div className="vsb-ad-left">
      <img src={vsb} alt="VSB" className="vsb-ad-logo" />

<div className="vsb-ad-title">Regístrate y juega con VSB</div>
<div className="vsb-ad-subtitle">
  Escanea el código y solicita tu acceso por WhatsApp
</div>
    </div>

    <div className="vsb-ad-right">
      <div className="vsb-ad-qr-box">
        <img src={qrImg} alt="QR WhatsApp" className="vsb-ad-qr" />
      </div>
      <div className="vsb-ad-cta">Escanea aquí</div>
    </div>
  </div>
    </>)
}

export default Publish;